import EmailService from 'services/EmailService';
import LibraryService from 'services/LibraryService';
import { MESSAGE_LIBRARY } from '../query-keys';
import {
  keepPreviousData,
  useInfiniteQuery,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { monitoringExceptionHelper } from 'instrumentation/helpers';

export const useListMessagesForContact = (id, ordering) => {
  const queryKey = [...MESSAGE_LIBRARY.CLIENT_MESSAGE, id];
  return useInfiniteQuery({
    initialPageParam: '1',
    queryKey: [...queryKey, ordering],
    queryFn: ({ pageParam }) => {
      return LibraryService.getContactSentMessages({
        id,
        ordering,
        page: pageParam,
      });
    },
    staleTime: 0,
    placeholderData: keepPreviousData,
    getNextPageParam: (lastPage, pages) => {
      return lastPage?.next
        ? new URL(lastPage.next).searchParams.get('page')
        : undefined;
    },
    getPreviousPageParam: (previousPage) => {
      return previousPage?.prev
        ? new URL(previousPage.prev).searchParams.get('page')
        : undefined;
    },
  });
};

export const useSentMessageById = (id, enabled = true) => {
  const queryFn = async () => {
    try {
      const res = await LibraryService.getContactSentMessageById(id);
      return res;
    } catch (error) {
      monitoringExceptionHelper(error);
      return { error: true, ...error.response };
    }
  };
  return useQuery({
    queryKey: [...MESSAGE_LIBRARY.MESSAGE, id],
    queryFn,
    enabled: Boolean(enabled && !!id),
  });
};

export const useSentMessageStats = (id) => {
  return useQuery({
    queryKey: [...MESSAGE_LIBRARY.MESSAGE_STATS, id],
    queryFn: () => LibraryService.getMessageStats(id),
    staleTime: 0,
  });
};

export const useSyncedEmailMessageContentQuery = (id) => {
  const queryFn = async () => {
    try {
      const res = await EmailService.getSyncedEmailMessageContent(id);
      return res;
    } catch (error) {
      monitoringExceptionHelper(error);
      return { error: true, ...error.response };
    }
  };
  return useQuery({
    queryKey: [...MESSAGE_LIBRARY.MESSAGE_SYNCED_EMAIL, id],
    queryFn,
    enabled: Boolean(id),
  });
};

export const useSendEmailMutation = () => {
  return useMutation({ mutationFn: LibraryService.sendEmail });
};
